import React from 'react';

export function useIntermediariesWithSelected(intermediaries, subscription) {
    return React.useMemo(() => {
        if (!intermediaries || intermediaries.length === 0) {
            return [];
        }

        if (!subscription?.intermediary?.invoicingId) {
            return intermediaries;
        }

        const selectedId = subscription.intermediary.invoicingId;
        const isInList = intermediaries.some(x => x.invoicingId === selectedId);

        if (isInList) {
            return intermediaries;
        }
        
        // If the intermediary from the subscription is not in the list, add it
        return [...intermediaries, subscription.intermediary];
    }, [intermediaries, subscription?.intermediary]);
}